import { ApiEndpoint } from "utils/baseFetcher";

export const isDataEmpty = (data: any, keys?: string[]) => {
  return (
    !data ||
    (keys || Object.keys(data)).every((key) => {
      return (
        data[key]?.code?.startsWith?.("KOY_") ||
        data[key]?.error?.code?.startsWith?.("KOY_")
      );
    })
  );
};

export function stockDataUrl(entityId: string): any {
  const url = new ApiEndpoint("/api/v3/consensus/stock-data");
  url.searchParams.append("entity-id", entityId);
  return url.href;
}

export function estimatesUrl(entityId: string): any {
  const url = new ApiEndpoint("/api/v3/consensus/estimates");
  url.searchParams.append("entity-id", entityId);
  return url.href;
}

export function consensusTargetUrl(entityId: string): any {
  const url = new ApiEndpoint("/api/v3/consensus/consensus-target");
  url.searchParams.append("entity-id", entityId);
  return url.href;
}

export function chartPriceUrl(entityId: string, since: Date | string): any {
  const url = new ApiEndpoint("/api/v3/consensus/graphs/price");
  url.searchParams.append("entity-id", entityId);
  url.searchParams.append("date-from", since.toString());
  return url.href;
}

export function chartEstimatesUrl(
  entityId: string,
  key: string,
  since: Date | string
): any {
  const url = new ApiEndpoint("/api/v3/consensus/graphs/estimates");
  url.searchParams.append("entity-id", entityId);
  url.searchParams.append("key", key);
  url.searchParams.append("date-from", since.toString());
  return url.href;
}
